import { lazy } from 'react'
import { useRoutes } from 'react-router-dom'

import { Auth, Loadable as L } from '@/components'

function Routes() {
  const Blank = L(lazy(() => import('./pages/Blank')))
  const Error404 = L(lazy(() => import('./components/Error404')))
  const Login = L(lazy(() => import('./pages/Login')))
  const Home = L(lazy(() => import('./pages/Home')))
  const TurmasList = L(lazy(() => import('./pages/Turmas/List')))
  const TurmasDetail = L(lazy(() => import('./pages/Turmas/Detail')))
  const TurmasAula = L(lazy(() => import('./pages/Turmas/Aula')))
  const EtapasAvaliacoes = L(lazy(() => import('./pages/Turmas/EtapasAvaliacoes')))
  const RelatorioAvaliacoes = L(lazy(() => import('./pages/Turmas/RelatorioAvaliacoes')))
  const LancamentoNotas = L(lazy(() => import('./pages/Turmas/LancamentoNotas')))
  const Perfil = L(lazy(() => import('./pages/Perfil')))
  const BibliotecaList = L(lazy(() => import('./pages/Biblioteca/List')))
  const Atividades = L(lazy(() => import('./pages/Atividades/List')))
  const AtividadeDetail = L(lazy(() => import('./pages/Atividades/Detail')))
  const Painel = L(lazy(() => import('./pages/Painel/List')))
  const Messages = L(lazy(() => import('./pages/Messages')))
  const Frequencia = L(lazy(() => import('./pages/Turmas/Frequencia')))
  const FrequenciaMedicina = L(lazy(() => import('./pages/Turmas/FrequenciaMedicina')))
  const Comunicados = L(lazy(() => import('./pages/Comunicados')))
  const ResetPassword = L(lazy(() => import('./pages/ResetPassword')))
  const Authentication = L(lazy(() => import('./pages/Authentication')))
  const FAQ = L(lazy(() => import('./pages/FAQ')))
  const ExtensionProject = L(lazy(() => import('./pages/Turmas/ProjetoExtensao')))
  const ExerciseQuestions = L(lazy(() => import('./pages/Exercises/Questions')))
  const ExerciseNewQuestion = L(lazy(() => import('./pages/Exercises/NewQuestion')))
  const ExerciseProofs = L(lazy(() => import('./pages/Exercises/Proofs')))
  const ExerciseNewProof = L(lazy(() => import('./pages/Exercises/NewProof')))
  const ExerciseProofDetails = L(lazy(() => import('./pages/Exercises/Proofs/Details')))
  const EntradaTardia = L(lazy(() => import('./pages/Turmas/EntradaTardia')))
  const SolicitationsPage = L(lazy(() => import('./pages/Turmas/Solicitations')))

  return useRoutes([
    { path: '/login', element: <Login /> },
    { path: '/resetar/:token', element: <ResetPassword /> },
    { path: '/authentication', element: <Authentication /> },
    {
      element: <Auth />,
      children: [
        { path: '/', element: <Home /> },
        { path: '/perfil', element: <Perfil /> },
        { path: '/comunicados', element: <Comunicados /> },
        {
          path: '/turmas',
          children: [
            { index: true, element: <TurmasList /> },
            { path: ':id', element: <TurmasDetail /> },
            { path: ':classId/aula/:id', element: <TurmasAula /> },
            { path: ':classId/avaliacoes', element: <EtapasAvaliacoes /> },
            { path: ':classId/frequencia', element: <Frequencia /> },
            { path: ':classId/frequencia/medicina', element: <FrequenciaMedicina /> },
            { path: ':classId/relatorio', element: <RelatorioAvaliacoes /> },
            {
              path: ':id/etapa/:CODETAPA/lancamento-notas/:CODPROVA',
              element: <LancamentoNotas />,
            },
            {
              path: ':classId/horas-extensao',
              element: <ExtensionProject />,
            },
            { path: ':classId/entrada-tardia', element: <EntradaTardia /> },
            {
              path: ':classId/solicitacoes',
              element: <SolicitationsPage />,
            },
          ],
        },
        { path: '/conteudo', element: <BibliotecaList /> },
        { path: '/painel', element: <Painel /> },
        {
          path: '/atividades',
          children: [
            { index: true, element: <Atividades /> },
            { path: ':id', element: <AtividadeDetail /> },
          ],
        },
        {
          path: 'mensagens',
          element: <Messages />,
        },
        { path: 'jornada-tenologica', element: <FAQ /> },
        {
          path: '/exercicios',
          children: [
            { path: 'questoes', element: <ExerciseQuestions /> },
            { path: 'nova-questao', element: <ExerciseNewQuestion /> },
            {
              path: 'provas',
              children: [
                {
                  index: true,
                  element: <ExerciseProofs />,
                },
                { path: ':id', element: <ExerciseProofDetails /> },
              ],
            },
            { path: 'nova-prova', element: <ExerciseNewProof /> },
          ],
        },
        { path: '*', element: <Blank /> },
      ],
    },
    { path: '/404', element: <Error404 /> },
  ])
}

export default Routes
